/* eslint-disable @typescript-eslint/no-explicit-any */
import { OnlyDev } from "src/shared/decorators/only-dev";

/* eslint-disable no-console */
enum Styles {
    NORMAL = "font-weight: bold; color: #444444",
    INFO = "font-weight: bold; color: #0099cc;",
    SUCCESS = "font-weight: bold; color: #00af3f;",
    WARNING = "font-weight: bold; color: #f39c12;",
    ERROR = "font-weight: bold; color: #ff0048;",
}

export class Log {
    @OnlyDev()
    static normal(message?: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.NORMAL, ...args);
        } else {
            console.log(`%c${message}`, Styles.NORMAL);
        }
    }

    @OnlyDev()
    static info(message: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.INFO, ...args);
        } else {
            console.log(`%c${message}`, Styles.INFO);
        }
    }

    @OnlyDev()
    static success(message: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.SUCCESS, ...args);
        } else {
            console.log(`%c${message}`, Styles.SUCCESS);
        }
    }

    @OnlyDev()
    static warn(message: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.WARNING, ...args);
        } else {
            console.log(`%c${message}`, Styles.WARNING);
        }
    }

    @OnlyDev()
    static error(message: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.ERROR, ...args);
        } else {
            console.log(`%c${message}`, Styles.ERROR);
        }
    }

    @OnlyDev()
    static showTable(data: Record<string, any>) {
        console.table(data);
    }

    @OnlyDev()
    static time(message: any) {
        console.time(`%c${message}`);
    }

    @OnlyDev()
    static timeEnd(message: any) {
        console.timeEnd(`%c${message}`);
    }
}
